import { gsap } from 'gsap';

const animationOptions = {
  duration: 0.2,
  ease: 'power2.inOut',
};

export function animateMenuOpen(navMenu, hamburgerRef) {
  if (navMenu) {
    gsap.set(navMenu, { 
      opacity: 0, 
      scale: 0.5, 
      transformOrigin: 'top right' 
    });
    gsap.to(navMenu, {
      ...animationOptions,
      opacity: 1,
      scale: 1,
      display: 'flex',
    });
  }
  if (hamburgerRef) {
    gsap.to(hamburgerRef.querySelector('.material-symbols-outlined'), {
      borderRadius: '24px 24px 24px 0px',
      duration: animationOptions.duration,
    });
  }
}

export function animateMenuClose(navMenu, hamburgerRef) {
  return new Promise((resolve) => {
    if (navMenu) {
      gsap.to(navMenu, {
        ...animationOptions,
        opacity: 0,
        scale: 0.5,
        onComplete: () => {
          gsap.set(navMenu, { display: 'none' });
          if (hamburgerRef) {
            gsap.to(hamburgerRef.querySelector('.material-symbols-outlined'), {
              borderRadius: '24px 24px 24px 24px',
              duration: animationOptions.duration * 0.3,
            });
          }
          resolve();
        }
      });
    } else {
      resolve();
    }
  });
}

export function animateNavHide(headerElement) {
  gsap.to(headerElement, {
    y: '-100%',
    duration: 0.5,
    ease: 'power2.inOut',
  });
}

export function animateNavShow(headerElement) {
  gsap.to(headerElement, {
    y: '0%',
    duration: 0.3,
    ease: 'power2.out',
  });

  const menuWrapper = headerElement.querySelector('.menu-wrapper');
  gsap.fromTo(menuWrapper, 
    { opacity: 0 },
    { opacity: 1, duration: 0.3, delay: 0.1, ease: 'power2.out' }
  );
}

export function updateLogoColor(logoSvg, isDarkPage) {
  if (logoSvg) {
    gsap.to(logoSvg, {
      color: isDarkPage ? 'var(--color-neutral-0)' : '',
      duration: animationOptions.duration,
    });
  }
}

export function initializeNavigationAnimations(navMenu) {
  if (navMenu) {
    gsap.set(navMenu, { 
      opacity: 0, 
      scale: 0.5, 
      transformOrigin: 'top right',
      display: 'none'
    });
  }
}
